
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { PhoneCall } from "lucide-react";

const AgentProfile = () => {
  return (
    <section className="py-12 px-6 bg-gradient-to-b from-[#f0f9ff] to-white relative w-full">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-6 bg-white p-6 rounded-lg shadow-md border border-[#e0f2fe]">
          <Avatar className="w-24 h-24 border-2 border-white shadow-md">
            <AvatarImage src="/lovable-uploads/bc0ef471-2061-4899-9ba7-69887b58aaf0.png" alt="Gladys Velasquez" />
            <AvatarFallback className="text-xl bg-[#0EA5E9]/20 text-[#0c4a6e]">GV</AvatarFallback>
          </Avatar>
          
          <div className="flex-1 text-center md:text-left">
            <h3 className="text-xl font-medium text-[#0c4a6e]">Gladys Velasquez</h3>
            <p className="text-[#0284c7] font-medium">Agente de Seguros Certificada</p>
            <p className="text-sm text-[#64748b] mt-1 mb-4">
              Con más de 10 años de experiencia en el sector de seguros.
            </p>
            
            <div className="flex flex-wrap justify-center md:justify-start gap-3">
              <Button 
                className="rounded-md px-4 bg-[#0284c7] hover:bg-[#0c4a6e] transition-colors shadow-sm text-sm"
                onClick={() => {
                  const contactSection = document.getElementById('contact');
                  if (contactSection) {
                    contactSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                Contactar Ahora
              </Button>
              <a 
                href="tel:+17865695142" 
                className="inline-flex items-center justify-center rounded-md px-4 py-2 bg-white border border-[#0284c7] text-[#0284c7] hover:bg-[#f0f9ff] shadow-sm text-sm"
              >
                <PhoneCall className="mr-2 h-4 w-4" />
                Llamar
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgentProfile;
